export const inboxWorkflowHelpDialogIds = {
  customerContactVerification: "inboxCustomerContactVerification",
  customerContactVerificationSourceCleanup: "inboxCustomerContactVerificationSourceCleanup",
  customerContactPointReview: "inboxCustomerContactPointReview",
  customerContactPointReviewSourceCleanup: "inboxCustomerContactPointReviewSourceCleanup",
  wrongRecipientReplacement: "inboxWrongRecipientReplacement",
  wrongRecipientSourceCleanup: "inboxWrongRecipientSourceCleanup",
  unclearAppointmentFeedbackAssignWorkOrder: "inboxUnclearAppointmentFeedbackAssignWorkOrder",
  unclearAppointmentFeedbackAssignRequesterCustomer:
    "inboxUnclearAppointmentFeedbackAssignRequesterCustomer",
  unclearAppointmentFeedbackPlanAppointment: "inboxUnclearAppointmentFeedbackPlanAppointment",
  unclearAppointmentFeedbackInformCustomer: "inboxUnclearAppointmentFeedbackInformCustomer",
  letterDeliverySelectAppointmentLetters: "inboxLetterDeliverySelectAppointmentLetters",
  letterDeliveryDecideAppointmentLetterDelivery:
    "inboxLetterDeliveryDecideAppointmentLetterDelivery",
  letterDeliveryDeliverAppointmentLetters: "inboxLetterDeliveryDeliverAppointmentLetters",
} as const

export type InboxWorkflowHelpDialogId =
  (typeof inboxWorkflowHelpDialogIds)[keyof typeof inboxWorkflowHelpDialogIds]
